//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'font-style',
  props: {
    control: {required: true},
    data: {required: true},
    product: {required: true},
  },
  data() {
    return {
      fontStyle: '',
    }
  },
  methods: {
    onFontStyleChanged(e) {
      const selectedFont = this.control.Options.find(x => x.value === e)
      console.log('font', selectedFont)
      this.$emit('updateValue', {
        controlType: this.control.type,
        controlName: this.control.name,
        value: e,
        secondValue: selectedFont.Desc
      })
    },
  },
}
